import axios from 'axios';
import { mockAdapter } from '@/mocks/mockAdapter';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';

export const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  // Switch mock↔API: VITE_USE_MOCK=true serve src/mocks/db.json (sem rede)
  ...(USE_MOCK ? { adapter: mockAdapter } : {}),
});

if (USE_MOCK) {
  // eslint-disable-next-line no-console
  console.info('%c[MOCK] API servida de src/mocks/db.json (VITE_USE_MOCK=true)', 'color:#7AA41F;font-weight:bold');
}

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('manager_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const hasToken = localStorage.getItem('manager_token');

      if (hasToken && currentPath !== '/login') {
        localStorage.removeItem('manager_token');
        localStorage.removeItem('manager_info');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
